import { BlogImageRoot } from './BlogImage.styles'

export type BlogImageType = {
  fields: {
    file: {
      url: string
      details: {
        image: {
          width: number
          height: number
        }
      }
    }
    title: string
  }
}

type BlogImageProps = {
  content: BlogImageType
}

export const BlogImage = ({ content, ...rest }: BlogImageProps) => {
  return (
    <BlogImageRoot {...rest}>
      <img src={`https:${content.fields.file.url}`} alt={content.fields.title} />
    </BlogImageRoot>
  )
}
